import { Button } from '@mui/material'
import React from 'react'

export function EmptyPage({ onAction }) {
  return (
    <div
      className='column column-center'
      style={{
        justifyContent: 'center',
        height: '100vh'
      }}
    >
      <div
        style={{
          width: 760,
          border: '1px solid #DBDBE6',
          borderRadius: '16px',
          background: '#fff'
        }}
        className='row row-center'
      >
        <div
          className='column'
          style={{
            padding: 40,
            alignItems: 'flex-start'
          }}
        >
          <p
            style={{
              fontWeight: 600,
              fontSize: 20,
              lineHeight: '130%',
              marginBottom: 16
            }}
          >
            Streamline Your Training and Response Processes
          </p>
          <p
            style={{
              marginBottom: 32
            }}
          >
            Automate key actions — from training assignments to threat feedback — so you can focus on what matters most.
            Let Cyberlift handle the routine tasks.
          </p>
          <Button
            variant='contained'
            style={{
              background: '#0246F8',
              textTransform: 'none',
              width: 210,
              borderRadius: 12,
              fontFamily: 'Plus Jakarta Sans'
            }}
            onClick={onAction}
          >
            Set Up Workflows
          </Button>
        </div>
        <img src='images/wf-empty-page-img.png' style={{ width: 360 }} alt='' />
      </div>
    </div>
  )
}
